import { FC, memo } from "react"
import { Icon, IconColor, IconProps } from "@/components/shared/Icon"
import "./index.scss"

interface TotalsProps {
   totalDefaultCells?: number
   totalCustomCells?: number
   totalWearables?: number
}

const Totals: FC<TotalsProps> = ({
   totalDefaultCells = 0,
   totalCustomCells = 0,
   totalWearables = 0,
}) => {
   const totals: {
      value: number
      icon: IconProps["name"]
   }[] = [
      {
         value: totalDefaultCells,
         icon: "cell",
      },
      {
         value: totalCustomCells,
         icon: "cellCustom",
      },
      {
         value: totalWearables,
         icon: "smartwatch",
      },
   ]

   return (
      <div className="floor-overview__totals">
         {totals
            .filter(({ value }) => value > 0)
            .map(({ value, icon }) => (
               <div
                  key={icon}
                  className="floor-overview__totals-item"
               >
                  <Icon
                     size="24"
                     color={IconColor.HONOLULU_BLUE}
                     name={icon}
                  />
                  <span className="floor-overview__totals-count">{value}</span>
               </div>
            ))}
      </div>
   )
}

export default memo(Totals)
